import * as yup from 'yup';

const schema = yup.object().shape({
  cep: yup.string().required('Campo obrigatório'),
  cidade: yup.string().required('Campo obrigatório'),
  estado: yup.string().required('Campo obrigatório'),
});

export default schema;
